import { motion } from "framer-motion";
import { ShoppingBag } from "lucide-react";
import { SHOP_URL, scrollToId } from "@/lib/config";

const LINKS = [
  { label: "The Show", href: "#show" },
  { label: "Teasers", href: "#teasers" },
  { label: "Apparel", href: "#apparel" },
  { label: "Community", href: "#community" },
];

export const Nav = () => (
  <motion.header
    initial={{ y: -70, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.9, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
    className="fixed top-0 inset-x-0 z-50 border-b border-[#D4AF37]/15 bg-[#070A0F]/75 backdrop-blur-xl"
    data-testid="main-nav"
  >
    <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
      <button
        onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
        className="font-display text-sm md:text-base tracking-[0.28em] gold-text"
        data-testid="nav-wordmark"
      >
        CAPTAIN'S CUT<span className="align-super text-[9px]">TM</span>
      </button>
      <nav className="hidden md:flex items-center gap-8">
        {LINKS.map((l) => (
          <button
            key={l.href}
            onClick={() => scrollToId(l.href)}
            className="text-[11px] tracking-[0.3em] uppercase text-[#94A3B8] hover:text-[#E8C15A] transition-colors duration-300"
            data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
          >
            {l.label}
          </button>
        ))}
      </nav>
      <div className="flex items-center gap-3">
        <button
          onClick={() => scrollToId("#apply")}
          className="hidden sm:block text-[11px] tracking-[0.3em] uppercase text-[#E8C15A] border border-[#D4AF37]/40 px-4 py-2 hover:bg-[#D4AF37]/10 transition-colors duration-300"
          data-testid="nav-apply-btn"
        >
          Apply
        </button>
        <a
          href={SHOP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-[11px] tracking-[0.25em] uppercase bg-[#D4AF37] text-[#070A0F] px-4 py-2 hover:bg-[#F3E08A] transition-colors duration-300"
          data-testid="nav-shop-btn"
        >
          <ShoppingBag size={13} /> Shop
        </a>
      </div>
    </div>
  </motion.header>
);
